import { createFileRoute } from '@tanstack/react-router'

import { ExposePage } from '@/components/Public/Projects/ExposePage'

/** The public exposé for one project — the entry point of the public loop,
 *  reached from an e-mail or an ad, with no session. */
function Expose() {
  const { id } = Route.useParams()
  const projectId = Number(id)

  return (
    <ExposePage projectId={Number.isFinite(projectId) ? projectId : null} />
  )
}

export const Route = createFileRoute('/public/projects/$id')({
  component: Expose,
})
